import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonBackButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonPage, IonTitle, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, documentTextOutline, openOutline, shieldCheckmarkOutline } from 'ionicons/icons';
import React, { useContext } from 'react';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './TermosPolitica.css';


type Props = {
  abrirMenu: boolean;
}

const TermosPolitica: React.FC<Props> = () => {

  const { setEsconderMenu, setNomeMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
  });

  return (
    <IonPage className="menu-layout-page termos-politica-page">
      <IonHeader className="ion-no-border">
        <IonToolbar className="menu-layout-toolbar">
          <IonButtons slot="start">
            <IonBackButton icon={arrowBack} text=''></IonBackButton>
          </IonButtons>
          <IonTitle slot="start">Privacidade e termos</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="menu-layout-content">
        <main className="menu-layout-container">
          <div className="menu-layout-heading">
            <h1>Privacidade e termos de uso</h1>
            <p>Consulte os documentos do Xeguei. Os arquivos em PDF abrem em uma nova aba.</p>
          </div>
          <nav className="menu-layout-grid termos-politica-grid" aria-label="Documentos de privacidade e termos de uso">
            <IonItem className="menu-layout-item" lines="none" detail detailIcon={openOutline}
              target="_blank" rel="noopener noreferrer"
              href="https://xeguei-plt-welcome.s3.sa-east-1.amazonaws.com/termos/empresa/Termos_de_uso.pdf"
              aria-label="Ler os termos de uso, PDF em nova aba">
              <IonIcon className="menu-layout-icon" slot="start" icon={documentTextOutline} aria-hidden="true" />
              <IonLabel><h2>Termos de uso</h2><p>Consulte as condições de uso da plataforma.</p></IonLabel>
            </IonItem>
            <IonItem className="menu-layout-item" lines="none" detail detailIcon={openOutline}
              target="_blank" rel="noopener noreferrer"
              href="https://xeguei-plt-welcome.s3.sa-east-1.amazonaws.com/termos/empresa/politica_de_privacidade.pdf"
              aria-label="Ler a política de privacidade, PDF em nova aba">
              <IonIcon className="menu-layout-icon" slot="start" icon={shieldCheckmarkOutline} aria-hidden="true" />
              <IonLabel><h2>Política de privacidade</h2><p>Conheça as informações sobre o tratamento dos seus dados.</p></IonLabel>
            </IonItem>
          </nav>
        </main>
      </IonContent>
    </IonPage>
  );
};

export default TermosPolitica;
